import {useEffect} from 'react';

import {
    useNavigate,
    useParams
} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {usePipelineTemplate} from '../hooks/usePipelineTemplate.ts';
import {usePipelineTemplatesSelection} from '../hooks/usePipelineTemplatesSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';


export const EditPage = () => {

    const {id: pipelineTemplateId} = useParams();

    if (typeof pipelineTemplateId === 'undefined') {
        throw new Error('pipelineTemplateId is required parameter');
    }

    const navigate = useNavigate();
    const onCancel = () => {
        navigate(`/pipeline-templates/${pipelineTemplateId}`);
    }

    const {
        record: pipelineTemplate,
        updateRecord,
    } = usePipelineTemplate(pipelineTemplateId);

    const {handleClearSelection} = usePipelineTemplatesSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);

    if (!pipelineTemplate) {
        return <PlatformLoader message='Loading pipeline template...Please wait'/>;
    }

    return (
        <FormPageLayout
            title={pipelineTemplate.name ? pipelineTemplate.name : pipelineTemplate.id}
            pageNavigation={<EditPageNavigation component={pipelineTemplate}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 6
                    }}>
                        <Profile record={pipelineTemplate}/>
                    </Grid.Col>
                </Grid>

                :
                <RecordForm
                    record={pipelineTemplate}
                    handleSubmit={updateRecord}
                    handleCancel={onCancel}
                />}


        </FormPageLayout>
    );
};
